import React from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  Box,
  AppBar,
  Toolbar,
  Button,
  Typography,
  Avatar,
} from '@material-ui/core'
import useStyles from './styles'
import { logOut } from './../../store/actions/auth/logOut'

export const Header = () => {
  const dispatch = useDispatch()

  const firstName = useSelector((state) => state.auth.authData.firstName)
  const lastName = useSelector((state) => state.auth.authData.lastName)
  const logOutHandler = () => {
    dispatch(logOut())
  }
  const classes = useStyles()
  return (
    <AppBar position='static' className={classes.appBar}>
      <Toolbar>
        <Box className={classes.links}>
          <Button
            className={classes.link}
            component={Link}
            to='/'
            size='medium'
            disableRipple
          >
            Home
          </Button>
          <Button
            className={classes.link}
            component={Link}
            to='/create'
            size='medium'
            disableRipple
          >
            Create
          </Button>
        </Box>
        <Box className={classes.user}>
          <Avatar className={classes.avatar}>{firstName.substr(0, 1)}</Avatar>
          <Typography
            className={classes.userData}
            variant='subtitle1'
            color='inherit'
          >
            {`Hi, ${firstName} ${lastName}!`}
          </Typography>
        </Box>
        <Button color='inherit' variant='outlined' onClick={logOutHandler}>
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  )
}
